import * as AuthService from '@/services/auth';
import { resetAllStores } from '@/utils/resetStores.utils';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ModelUserResponse } from '@layup/api-sdk';

export const useUserStore = defineStore('users', {
  state: () => {
    const user = ref<ModelUserResponse>({});
    const expiresAt = new Date();

    return {
      user,
      expiresAt,
    };
  },
  getters: {
    isAuthenticated(state) {
      return !!state.user && '_id' in state.user && state.expiresAt > new Date();
    },
  },
  actions: {
    async signIn(user: ModelUserResponse, rememberMe = false) {
      resetAllStores();
      this.user = user;
      const now = Date.now();
      let sessionExpiry = now + 24 * 60 * 60 * 1000; // 24hrs
      if (rememberMe) {
        sessionExpiry = now + 30 * 24 * 60 * 60 * 1000; // 30 days
      }
      this.expiresAt = new Date(sessionExpiry);
    },
    async signOut() {
      resetAllStores();
      await AuthService.signOut();
      // We only need to session storage while we have multiple sites. Can be removed once merchant and shopper are merged.
      sessionStorage.clear();
    },
    reset() {
      this.$reset();
    },
  },
  persist: {
    storage: sessionStorage,
  },
});
